function findElementByIdDraggable(id, obj) {
    const idString = id?.toString();
    if (obj?.id?.toString() === idString) {
        return obj;
    }
    if (obj.children) {
        for (let i = 0; i < obj.children.length; i++) {
            const result = findElementByIdDraggable(idString, obj.children[i]);
            if (result) {
                return result;
            }
        }
    }
    return null;
}
export default findElementByIdDraggable;
//# sourceMappingURL=findElementByIdDraggable.js.map